export const wordsList = {
  carro: ["Motor", "Porta", "Capô", "Pneu", "Antena"],
  fruta: ["Banana", "Maçã", "Pêra", "Mamão", "Laranja"],
  corpo: [
    "Braço",
    "Perna",
    "Cérebro",
    "Pescoço",
    "Olhos",
    "Cabeça",
    "Ombro",
    "Pés",
    "Mãos",
  ],
  computador: ["Mouse", "Teclado", "Monitor", "Gabinete"],
  programação: ["Linguagem", "Framework", "JavaScript", "React", "HTML", "CSS"],
  alimento: ["Arroz", "Feijão", "Carne", "Leite", "Ovo", "Frango"],
};
